import VsimavecHeadSad from '../../assets/vsimavec-head-sad.svg';
import { PropsWithChildren } from 'react';

export function EmptyState({ children }: PropsWithChildren) {
    return (
        <div className="flex flex-col items-center justify-center text-center text-ink-900">
            <img
                height={128}
                src={VsimavecHeadSad}
                alt="Tato kategorie zatím neobsahuje žádná cvičení."
                className="mb-5"
            />
            <h3 className="max-w-[520px]">{children}</h3>
        </div>
    );
}
